import {
  Box,
  MenuItem,
  Select,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { CustomFieldInstance } from "lib/features/checkout/checkoutService";
import { additionalInformationFareharborStyles as styles } from "styles/Checkout/additionalInformationFareharbor.styles";
import { ReactComponent as CustomDropDownIcon } from "../../../assets/icons/black_down_arrow.svg";

interface CustomerInformationFareharborProps {
  customFields: CustomFieldInstance[];
  setCustomFields: React.Dispatch<React.SetStateAction<CustomFieldInstance[]>>;
  setTotalCost: React.Dispatch<React.SetStateAction<number>>;
}

const CustomerInformationFareharbor: React.FC<
  CustomerInformationFareharborProps
> = ({ customFields, setCustomFields, setTotalCost }) => {
  const theme = useTheme();

  const handleFieldChange = (value: string | number, i: number) => {
    const updatedFields = [...customFields];
    const field = updatedFields[i];

    if (field.custom_field.type === "extended-option") {
      const index = field.custom_field.extended_options.findIndex(
        (x) => x.pk === Number(value)
      );

      // Ensure index is valid
      if (index !== -1) {
        if (field.custom_field.extended_options[index]?.total > 0) {
          setTotalCost(field.custom_field.extended_options[index].total / 100);
        }

        field.custom_field.extended_options[index].is_selected = true;
        field.custom_field.value_given = value.toString();

        setCustomFields(updatedFields);
      } else {
        console.error("Error: Selected option not found in extended_options");
      }
    } else {
      field.custom_field.value_given = value.toString();
      setCustomFields(updatedFields);
    }
  };

  return (
    <>
      {customFields
        .filter((customField) => {
          // Show only short, long, or extended-option with all options having total = 0
          if (customField.custom_field.type === "extended-option") {
            return customField.custom_field.extended_options.every(
              (option) => option?.total === 0
            );
          }
          return (
            customField.custom_field.type === "short" ||
            customField.custom_field.type === "long"
          );
        })
        .map((customField, i) => {
          const isRequired = customField.custom_field.is_required;

          return (
            <Box key={customField.custom_field.pk} mb={2}>
              <Box sx={styles.nonOptionHeader()}>
                <Typography sx={styles.fieldTitleFH(theme)}>
                  {customField.custom_field.title}
                </Typography>
                {isRequired && (
                  <Typography component="span" sx={styles.requiredAsterisk}>
                    *
                  </Typography>
                )}
              </Box>

              {customField.custom_field.type === "short" && (
                <TextField
                  fullWidth
                  required={isRequired}
                  onChange={(event) => handleFieldChange(event.target.value, i)}
                  placeholder={customField.custom_field.description}
                  sx={styles.textFieldStyleFH}
                />
              )}

              {customField.custom_field.type === "long" && (
                <TextField
                  fullWidth
                  multiline
                  required={isRequired}
                  rows={4}
                  onChange={(event) => handleFieldChange(event.target.value, i)}
                  placeholder={customField.custom_field.description}
                  sx={styles.textFieldStyle}
                />
              )}

              {customField.custom_field.type === "extended-option" && (
                <>
                  <Select
                    fullWidth
                    required={isRequired}
                    defaultValue={""}
                    IconComponent={() => <CustomDropDownIcon style={{ width: "16px", height: "16px", marginRight: "12px" }} />}
                    onChange={(event) =>
                      handleFieldChange(event.target.value, i)
                    }
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxWidth: 300,
                        },
                      },
                    }}
                    sx={styles.extendedOptionSelect}
                  >
                    {customField.custom_field.extended_options.map((option) => (
                      <MenuItem
                        key={option.pk}
                        value={option.pk}
                        sx={styles.menuItem}
                      >
                        {option.name}
                      </MenuItem>
                    ))}
                  </Select>
                  {customField.custom_field.description && (
                    <Typography
                      sx={styles.optionDescriptionFH}
                    >
                      {customField.custom_field.description}
                    </Typography>
                  )}
                </>
              )}
            </Box>
          );
        })}
    </>
  );
};

export default CustomerInformationFareharbor;
